import type { TFunctionParamsArgument, TypeSafeTFunction } from '~/shared/hooks/useTranslation';
import type { TranslationKey } from '~/shared/types/translationKeys';

export const createTranslationMap =
  <T extends string, U extends TranslationKey<'common'>>(callback: (value: T) => U) =>
  (t: TypeSafeTFunction, value: T, ...params: TFunctionParamsArgument<'common', U>) =>
    // Without the unnecessary type assertion, Typescript thinks there's a
    // problem. This might be a bug (?).
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    t(callback(value), ...(params as TFunctionParamsArgument<'common', U>));
